import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, FormControl, Typography, TextField } from "@mui/material";
import { FULL_TIME, PART_TIME } from "../../util/constants";
import StarsSelectInput from "../fundamentals/StarsSelectInput";
import { sortOnCaseSensitiveTexts } from "../../util/commonUtils";

const PersonalInfo = ({
  employeeData,
  employeeDataErrors,
  handleEmployeeFieldChange,
  handlePhoneNumberChange,
  workgroup,
}) => {
  return (
    <Box marginTop={2}>
      <Grid container>
        <Typography variant="overline" sx={{ color: "primary.swaBlue", fontWeight: "bold" }}>
          PERSONAL
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid container item alignItems="center">
          <Grid item xs={5} className="bold-text">
            Phone #
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                label="Phone #"
                variant="outlined"
                value={employeeData.phoneNumber || ""}
                onChange={(e) => handlePhoneNumberChange(e.target.value)}
                error={!!employeeDataErrors?.phoneNumber}
                helperText={employeeDataErrors?.phoneNumber || ""}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item xs={5} className="bold-text">
            Home Station
          </Grid>
          <Grid item xs={6}>
            {employeeData.homeStation}
          </Grid>
        </Grid>
        {employeeData.tempStation && (
          <Grid container item>
            <Grid item xs={5} className="bold-text">
              Temp Station
            </Grid>
            <Grid item xs={6}>
              {employeeData.tempStation}
            </Grid>
          </Grid>
        )}
        <Grid container item>
          <Grid item xs={5} className="bold-text">
            Workgroup
          </Grid>
          <Grid item xs={6}>
            {workgroup}
          </Grid>
        </Grid>
        <Grid container item alignItems="center">
          <Grid item xs={5} className="bold-text">
            FT/PT
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <StarsSelectInput
                label="FT/PT"
                menuMessage="Select FT/PT"
                value={employeeData.ftpt || ""}
                allOptions={[FULL_TIME, PART_TIME]}
                sortComparator={sortOnCaseSensitiveTexts}
                errors={employeeDataErrors?.ftpt || ""}
                onChange={(e) => handleEmployeeFieldChange("ftpt", e.target.value)}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

PersonalInfo.propTypes = {
  employeeData: PropTypes.object.isRequired,
  employeeDataErrors: PropTypes.object,
  handleEmployeeFieldChange: PropTypes.func.isRequired,
  handlePhoneNumberChange: PropTypes.func.isRequired,
  workgroup: PropTypes.func.isRequired,
};

export default PersonalInfo;
